import { Helper } from './../../shared/helper';
import { FlightService } from './../flight.service';
import {
  AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChildren,
  ViewEncapsulation
} from '@angular/core';

import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormArray, FormBuilder, FormControl, FormControlName, FormGroup, Validators, AbstractControl} from '@angular/forms';
import {IFlightGroup} from '../../flight_group/flight-group';
import {FlightGroupService} from '../../flight_group/flight-group.service';
import {LocationService} from '../../locations/location.service';
import {AircraftService} from '../../aircrafts/aircraft.service';
import {ILocation} from '../../locations/location';
import {IAircraft} from '../../aircrafts/aircraft';
import {environment} from '../../../environments/environment';
import {GenericValidator} from '../../shared/generic-validator';
import {Observable} from 'rxjs/Observable';
import {CustomValidators} from '../../shared/custom-validators';
import { DatePipe } from '@angular/common';

@Component({
  templateUrl: './flight.component.html',
  styleUrls: ['./flight.component.css']
})
export class FlightComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];

  flightForm: FormGroup;
  flightGroups: IFlightGroup[];
  locations: ILocation[];
  aircrafts: IAircraft[];
  errorMessage: string;
  displayMessages: { [key: string]: string } = {};
  private _validationMessages: { [key: string]: { [key: string]: string } };
  private _genericValidator: GenericValidator;
  private _locationUrl = environment.locationUrl;
  _WEEKDAYS = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  timePattern = '([01][0-9]|2[0-3]):[0-5][0-9]$';
  asincFromDataResolve: any;
  asincFromData = new Promise((resolve, reject) => {
    this.asincFromDataResolve = resolve;
  });
  requestCountNum = 0;
  modalState = 'add';
  disableForm = true;

  get times(): FormArray {
    return <FormArray>this.flightForm.get('times');
  }

  get weekdays(): FormArray {
    return <FormArray>this.flightForm.get('weekdays');
  }

  get repetition(): AbstractControl {
    return this.flightForm.get('repetition');
  }

  constructor(
    public activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _flightGroupService: FlightGroupService,
    private _locationService: LocationService,
    private _aircraftService: AircraftService,
    private flightService: FlightService,
    private helper: Helper,
    private datePipe: DatePipe
  ) {
    this._flightGroupService.getFlightGroups({}).subscribe(
      res => {
        this.flightGroups = res.body;
        this.requestCount();
      },
      error => {}
    );
    this._locationService.getLocations({}).subscribe(
      res => {
        this.locations = res.body;
        this.requestCount();
      },
      error => {}
    );
    this._aircraftService.getAircrafts({}).subscribe(
      res => {
        this.aircrafts = res.body;
        this.requestCount();
      },
      error => {}
    );

    this._validationMessages = this.helper.getValidationMessages();
    this._genericValidator = new GenericValidator(this._validationMessages);
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.flightForm = this._fb.group({
      id: [null],
      flightGroup: ['', Validators.required],
      flightNumber: ['', Validators.required],
      locationGroup: this._fb.group(
        {
          departure: ['', Validators.required],
          destination: ['', Validators.required]
        },
        { validator: CustomValidators.locationMatcher }
      ),
      priceFull: ['', [Validators.required, Validators.min(1)]],
      priceChild: ['', [Validators.required, Validators.min(1)]],
      priceInfant: ['', [Validators.required, Validators.min(0)]],
      aircraftId: ['', Validators.required],
      aircraftName: ['', Validators.required],
      seatsTotal: ['', [Validators.required, Validators.min(0)]],
      seatsOnlineTotal: ['', [Validators.required, Validators.min(0)]],
      dateTime: ['', Validators.required],
      timeDate: [
        '',
        [Validators.required, Validators.pattern(this.timePattern)]
      ],
      repetition: [false],
      flightDuration: '',
      flightDescriptionEn: '',
      flightDescriptionGe: '',
    });

    this.repetition.valueChanges.subscribe(val => {
      if (val) {
        this.changeFormState(true);
      } else {
        this.changeFormState(false);
      }
    });

    // this.flightForm.controls.timeDate.valueChanges.subscribe(val => {
    //   const patt = new RegExp('([01][0-9]|2[0-3]):[0-5][0-9]$');
    //   if (patt.test(val)) {
    //     const dateTime = this.flightForm.controls.dateTime.value;
    //     this.helper.formatDateTime(dateTime, val);
    //   }
    // });
  }

  requestCount() {
    this.requestCountNum += 1;
    if (this.requestCountNum === 3) {
      setTimeout(() => {
        this.asincFromDataResolve();
        this.disableForm = false;
      }, 100);
    }
  }

  patchForm(formData: any) {
    this.modalState = 'edit';
    this.asincFromData.then(() => {
      const formatedDateTime = this.helper.getDateTime(formData.flightDateTime);
      console.log(formData);
      this.flightForm.patchValue({
        id: formData.id,
        flightGroup: formData.flightGroup.id,
        flightNumber: formData.flightNumber,
        locationGroup: {
          departure: formData.departure.id,
          destination: formData.destination.id
        },
        priceChild: formData.priceChild,
        priceFull: formData.priceFull,
        priceInfant: formData.priceInfant,
        seatsTotal: formData.seatsTotal,
        aircraftName: formData.aircraftName,
        seatsOnlineTotal: formData.seatsOnlineTotal,
        dateTime: formatedDateTime.date,
        timeDate: formatedDateTime.time,
        aircraftId: formData.aircraftId,
        flightDuration: formData.flightDuration,
        flightDescriptionEn: formData.flightDescriptionEn,
        flightDescriptionGe: formData.flightDescriptionGe
      });
    });
  }

  changeFormState(repetition: boolean): void {
    const form = this.flightForm;
    if (repetition) {
      form.addControl(
        'dateRangeGroup',
        this._fb.group(
          {
            from_date: ['', Validators.required],
            to_date: ['', Validators.required]
          },
          { validator: CustomValidators.dateRange }
        )
      );
      form.addControl(
        'times',
        this._fb.array([], CustomValidators.minLengthArray(1))
      );
      form.addControl('weekdays', new FormControl([], [Validators.required]));
      form.removeControl('dateTime');
      form.removeControl('timeDate');
    } else {
      form.addControl('dateTime', new FormControl('', [Validators.required]));
      form.addControl(
        'timeDate',
        new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(this.timePattern)
          ])
        )
      );
      form.removeControl('dateRangeGroup');
      form.removeControl('times');
      form.removeControl('weekdays');
    }
  }

  selectDay(i: number) {
    const arr = this.flightForm.value.weekdays;
    const T = arr.indexOf(i);
    if (T > -1) {
      arr.splice(T, 1);
      this.times.removeAt(T);
    } else {
      arr.push(i);
      this.times.push(
        new FormControl('', [
          Validators.required,
          Validators.pattern(this.timePattern)
        ])
      );
    }
    this.weekdays.setValue(arr);
    this.flightForm.updateValueAndValidity();
  }

  timePick(e: any, i: number): void {
    const s = e.target.value;
    if (s.length === 2 && s.slice(-1) !== ':') {
      this.times.controls[i].setValue(s + ':');
    }
  }
  timePickAlone(e: any): void {
    const s = e.target.value;
    if (s.length === 2 && s.slice(-1) !== ':') {
      this.flightForm.controls['timeDate'].setValue(s + ':');
    }
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements.map(
      (formControl: ElementRef) =>
        Observable.fromEvent(formControl.nativeElement, 'blur')
    );

    Observable.merge(this.flightForm.valueChanges, ...controlBlurs)
      .debounceTime(200)
      .subscribe(value => {
        this.displayMessages = this._genericValidator.processMessages(
          this.flightForm
        );
      });
  }

  aircraftChange(e) {
    const value = e.target.value;
    if (value) {
      const aircraft = this.aircrafts.find(a => a.id === parseInt(value, 10));
      this.flightForm.patchValue({
        aircraftName: aircraft.name,
        seatsTotal: aircraft.seats,
        seatsOnlineTotal: aircraft.seats
      });
    }
  }

  flightGroupChange(e) {
    const value = e.target.value;
    if (value) {
      const flightGroup = this.flightGroups.find(
        obj => obj.id === parseFloat(value)
      );
      this.flightForm.patchValue({
        flightNumber: flightGroup.flightNumber,
        locationGroup: {
          departure: flightGroup.departure.id,
          destination: flightGroup.destination.id
        },
        priceFull: flightGroup.price,
        priceChild: flightGroup.price * 70 / 100,
        priceInfant: 0,
        flightDuration: flightGroup.flightDuration,
        flightDescriptionEn: flightGroup.flightDescriptionEn,
        flightDescriptionGe: flightGroup.flightDescriptionGe,
      });
    }
  }

  saveFlight() {
    if (this.flightForm.invalid) {
      return;
    }
    this.disableForm = true;
    const formValue = this.flightForm.value;
    formValue.aircraftId = parseInt(formValue.aircraftId, 10);
    if (formValue.repetition) {
      const dateRangeGroup = formValue.dateRangeGroup;
      if (typeof dateRangeGroup.from_date === 'object') {
        dateRangeGroup.from_date = this.helper.formatDate(
          dateRangeGroup.from_date
        );
        dateRangeGroup.to_date = this.helper.formatDate(dateRangeGroup.to_date);
      }
      Object.assign(formValue, dateRangeGroup);
    } else {
      formValue.flightDateTime = this.helper.formatDateTime(
        formValue.dateTime,
        formValue.timeDate
      );
      formValue.flightGroup = '/flight_groups/' + formValue.flightGroup;
      formValue.locationGroup.departure =
        '/locations/' + formValue.locationGroup.departure;
      formValue.locationGroup.destination =
        '/locations/' + formValue.locationGroup.destination;
    }
    Object.assign(formValue, formValue.locationGroup);
    delete formValue.dateTime;
    delete formValue.timeDate;
    delete formValue.locationGroup;
    console.log(formValue);

    if (this.modalState === 'edit') {
      this.flightService.updateFlight(formValue).subscribe(res => {
        this.closeAndRessetForm(res);
      }, (error: any) => (this.errorMessage = <any>error));
      return;
    }

    // TODO: this is wrong
    formValue.seatsTaken = 0;
    formValue.seatsOnlineTaken = 0;

    this.flightService
      .createFlights(formValue, formValue.repetition)
      .subscribe(res => {
        this.closeAndRessetForm(res);
      }, (error: any) => (this.errorMessage = <any>error));
  }

  closeAndRessetForm(res) {
    this.activeModal.close(res);
    this.flightForm.reset();
  }

  closeActiveModal() {
    if (this.flightForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/flights/single/flight.component.ts